/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsTranslatedString
 */
export interface DigitizingserviceMelcoDigitizingModelsTranslatedString {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsTranslatedString
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsTranslatedString
     */
    text?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsTranslatedStringFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsTranslatedString {
    return DigitizingserviceMelcoDigitizingModelsTranslatedStringFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsTranslatedStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsTranslatedString {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'language': !exists(json, 'language') ? undefined : json['language'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsTranslatedStringToJSON(value?: DigitizingserviceMelcoDigitizingModelsTranslatedString | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'language': value.language,
        'text': value.text,
    };
}


